import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import { DateStyles } from "../../constants/CentricConstants";
import { statusColours } from "../../constants/ColourConstants";
import { FormattedDate } from "react-intl";
import RaisedButton from 'material-ui/RaisedButton';


import InfoIcon from "material-ui/svg-icons/action/info";

import UserActions from '../../actions/UserActionCreator';
import UserSkillStore from '../../stores/UserSkillStore';

class UserSkillInformationSegment extends Component {

    componentWillMount() {
        UserActions.getUserSkill(this.props.userId, this.props.skillId);
    }

    componentWillReceiveProps({userId, skillId}, nextContext) {
        if (userId !== this.props.userId || skillId !== this.props.skillId) {
            UserActions.getUserSkill(userId, skillId);
        }
    }

    render() {
        if (!this.props.userId || !this.props.skillId) { return null; } //guard: required props

        return (
            <Card className="cent-card">
                <CardHeader
                    title="Skill acquisition"
                    subtitle=""
                    avatar={<InfoIcon color={statusColours.default} />}
                />
                {!!this.state.userSkillId && (
                    <CardText className="cent-card-text">
                        <ul className="cent-list-plain">
                            <li><em>Acquired: </em>{!!this.state.dateAcquired && <FormattedDate value={this.state.dateAcquired} {...DateStyles.long} />}</li>
                            {!!this.state.dateExpired && (
                                <li><em>Expires: </em>{!!this.state.dateExpired && <FormattedDate value={this.state.dateExpired} {...DateStyles.long} />}</li>
                            )}
                            {!!this.state.score && (
                                <li><em>Score: </em>{this.state.score}</li>
                            )}
                        </ul>
                    </CardText>
                )}

                {!!this.state.userSkillId && !!this.state.certificateId && (
                    <CardActions className="cent-card-actions">
                        <RaisedButton
                            className="button-raised"
                            key="btn_download"
                            label="Download Certificate"
                            fullWidth={true}
                            onTouchTap={() => window.open(`/usr/user/${this.props.userId}/certificate/${this.state.userSkillId}/certificate.pdf`,  '_blank')}
                            secondary
                        />
                    </CardActions>
                )}

            </Card>
        );
    }
}

UserSkillInformationSegment.getStores = () => [UserSkillStore];

UserSkillInformationSegment.calculateState = (prevState, {userId, skillId}) => {
    const { skillCode, dateAcquired, dateExpired, score, certificateId, id } = UserSkillStore.getBySkillId(userId, skillId) || {};
    return ({ skillCode, dateAcquired, dateExpired, score, certificateId, userSkillId: id });
};

UserSkillInformationSegment.propTypes = {
    userId: PropTypes.number.isRequired,
    skillId: PropTypes.number.isRequired
};

export default Container.create(UserSkillInformationSegment, {withProps: true});
